module.exports = __webpack_public_path__ + "img/v3-bibtex-drag.48c45195.png";